import { Layout, icons, useToast } from '@lifebit-ai/lds'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import useUser from 'hooks/useUser'

import * as styles from './UserSettingsPopover.styles'

export const USER_SETTINGS_AVATAR_TEST_ID = 'user-settings-avatar-test-id'
export const USER_SETTINGS_POPOVER_TEST_ID = 'user-settings-popover-test-id'

export const ACCOUNT_MENU_ITEM_TEXT = 'Manage Account'
export const LOGOUT_MENU_ITEM_TEXT = 'Log out'

enum UserSettingsOptions {
  Logout = 'logout'
}

interface UserSettingsPopoverProps {
  userFirstChar: string
  user?: UserAuth
}

const UserSettingsPopoverContent: React.FC<UserSettingsPopoverProps> = ({ userFirstChar, user }) => {
  const toast = useToast()
  const { logout } = useUser()
  const navigate = useNavigate()

  const handleOnMenuItemClick = (menuOption: UserSettingsOptions) => {
    switch (menuOption) {
      case UserSettingsOptions.Logout:
        logout()
        toast({ message: 'Logout successful.' })
        navigate('/')
        break
    }
  }

  return (
    <styles.UserSettingsPopoverContainer data-testid={USER_SETTINGS_POPOVER_TEST_ID}>
      <styles.HeaderContainer>
        <styles.UserSettingsLargeAvatar>{userFirstChar}</styles.UserSettingsLargeAvatar>
        <styles.HeaderRightContainer>
          <styles.UserEmail>{user?.user.email}</styles.UserEmail>
        </styles.HeaderRightContainer>
      </styles.HeaderContainer>
      <Layout.Separator />
      <styles.LogoutContainer onClick={() => handleOnMenuItemClick(UserSettingsOptions.Logout)}>
        <styles.LogoutText>{LOGOUT_MENU_ITEM_TEXT}</styles.LogoutText>
        <icons.LogoutSmall />
      </styles.LogoutContainer>
    </styles.UserSettingsPopoverContainer>
  )
}

export default UserSettingsPopoverContent
